import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Card, CardHeader, CardBody, CardFooter, Input } from 'reactstrap';
import { useFetchWrapper } from '../../../hooks/useFetchWrapper';
import { ContentBlock } from '../../Shared/Content/ContentBlock';

interface IFleetProps {
    fleetID: string,
    applicationName: string,
    submitHandler: () => void,
    closeHandler: (e: any) => void
}

interface IFuelType {
    fuelTypeID: number,
    fuelTypeName: string,
    energyPrice: number
}

export const FineTuneControl: React.FC<IFleetProps> = ({ fleetID, applicationName, submitHandler, closeHandler }) => {
    const fetchWrapper = useFetchWrapper();

    const fuelPriceMax = 15;
    const fuelPriceMin = 1;
    const electricPriceMax = .42;
    const electricPriceMin = .01;

    const [fuelPriceList, setFuelPriceList] = useState([]);
    const [electricityPrice, setElectricityPrice] = useState('0.00');
    const [gasPrice, setGasPrice] = useState('0.00');
    const [dieselPrice, setDieselPrice] = useState('0.00');
    const [propranePrice, setPropanePrice] = useState('0.00');
    const [anyValueHasChanged, setAnyValueHasChanged] = useState(false);
    const [electricRangeInvalid, setElectricRangeInvalid] = useState(false);
    const [gasRangeInvalid, setGasRangeInvalid] = useState(false);
    const [dieselRangeInvalid, setDieselRangeInvalid] = useState(false);
    const [propaneRangeInvalid, setPropaneRangeInvalid] = useState(false);

    const [electricPriceUpDisabled, setElectricPriceUpDisabled] = useState(false);
    const [electricPriceDownDisabled, setElectricPriceDownDisabled] = useState(false);
    const [gasPriceUpDisabled, setGasPriceUpDisabled] = useState(false);
    const [gasPriceDownDisabled, setGasPriceDownDisabled] = useState(false);
    const [dieselPriceUpDisabled, setDieselPriceUpDisabled] = useState(false);
    const [dieselPriceDownDisabled, setDieselPriceDownDisabled] = useState(false);
    const [propanePriceUpDisabled, setPropanePriceUpDisabled] = useState(false);
    const [propanePriceDownDisabled, setPropanePriceDownDisabled] = useState(false);

    useEffect(() => {
        getPricing();
    }, []);

    useEffect(() => {
        console.log("a value has changed.");
    }, [anyValueHasChanged]);

    const electricityPriceInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setElectricityPrice(e.currentTarget.value);
        setAnyValueHasChanged(true);
        if (!isNaN(parseFloat(e.currentTarget.value))) {
            var price = parseFloat(e.currentTarget.value);
            if (price >= electricPriceMax) {
                setElectricPriceUpDisabled(true);
                setElectricPriceDownDisabled(false);
            }
            else if (price <= electricPriceMin) {
                setElectricPriceDownDisabled(true);
                setElectricPriceUpDisabled(false);
            }
        }
    }

    const gasPriceInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setGasPrice(e.currentTarget.value);
        setAnyValueHasChanged(true);
        if (!isNaN(parseFloat(e.currentTarget.value))) {
            var price = parseFloat(e.currentTarget.value);
            if (price >= fuelPriceMax) {
                setGasPriceUpDisabled(true);
                setGasPriceDownDisabled(false);
            }
            else if (price <= fuelPriceMin) {
                setGasPriceDownDisabled(true);
                setGasPriceUpDisabled(false);
            }
        }
    }

    const dieselPriceInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setDieselPrice(e.currentTarget.value);
        setAnyValueHasChanged(true);
        if (!isNaN(parseFloat(e.currentTarget.value))) {
            var price = parseFloat(e.currentTarget.value);
            if (price >= fuelPriceMax) {
                setDieselPriceUpDisabled(true);
                setDieselPriceDownDisabled(false);
            }
            else if (price <= fuelPriceMin) {
                setDieselPriceDownDisabled(true);
                setDieselPriceUpDisabled(false);
            }
        }
    }

    const propanePriceInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setPropanePrice(e.currentTarget.value);
        setAnyValueHasChanged(true);
        if (!isNaN(parseFloat(e.currentTarget.value))) {
            var price = parseFloat(e.currentTarget.value);
            if (price >= fuelPriceMax) {
                setPropanePriceUpDisabled(true);
                setPropanePriceDownDisabled(false);
            }
            else if (price <= fuelPriceMin) {
                setPropanePriceDownDisabled(true);
                setPropanePriceUpDisabled(false);
            }
        }
    }

    const incrementPrice = (type: string) => {
        var price = 0;
        switch (type) {
            case 'Electric':
                price = parseFloat(electricityPrice);
                price = price + .0100;
                if (price <= electricPriceMax && price >= electricPriceMin) {
                    setElectricityPrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setElectricPriceUpDisabled(false);
                    setElectricPriceDownDisabled(false);
                }
                if (price >= electricPriceMax) {
                    setElectricityPrice(electricPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setElectricPriceUpDisabled(true);
                    setElectricPriceDownDisabled(false);
                }
                else if (price <= electricPriceMin) {
                    setElectricityPrice(electricPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setElectricPriceDownDisabled(true);
                    setElectricPriceUpDisabled(false);
                }
                break;
            case 'Gas':
                price = parseFloat(gasPrice);
                price = price + .0100;
                if (price >= fuelPriceMin && price <= fuelPriceMax) {
                    setGasPrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setGasPriceUpDisabled(false);
                    setGasPriceDownDisabled(false);
                }
                if (price >= fuelPriceMax) {
                    setGasPrice(fuelPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setGasPriceUpDisabled(true);
                    setGasPriceDownDisabled(false);
                }
                else if (price <= fuelPriceMin) {
                    setGasPrice(fuelPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setGasPriceDownDisabled(true);
                    setGasPriceUpDisabled(false);
                }
                break;
            case 'Diesel':
                price = parseFloat(dieselPrice);
                price = price + .0100;
                if (price >= fuelPriceMin && price <= fuelPriceMax) {
                    setDieselPrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setDieselPriceUpDisabled(false);
                    setDieselPriceDownDisabled(false);
                }
                if (price >= fuelPriceMax) {
                    setDieselPrice(fuelPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setDieselPriceUpDisabled(true);
                    setDieselPriceDownDisabled(false);
                }
                else if (price <= fuelPriceMin) {
                    setDieselPrice(fuelPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setDieselPriceDownDisabled(true);
                    setDieselPriceUpDisabled(false);
                }
                break;
            case 'Propane':
                price = parseFloat(propranePrice);
                price = price + .0100;

                if (price >= fuelPriceMin && price <= fuelPriceMax) {
                    setPropanePrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setPropanePriceUpDisabled(false);
                    setPropanePriceDownDisabled(false);
                }
                if (price >= fuelPriceMax) {
                    setPropanePrice(fuelPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setPropanePriceUpDisabled(true);
                    setPropanePriceDownDisabled(false);
                }
                else if (price <= fuelPriceMin) {
                    setPropanePrice(fuelPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setPropanePriceDownDisabled(true);
                    setPropanePriceUpDisabled(false);
                }
                break;
        }
        setElectricRangeInvalid(false);
        setGasRangeInvalid(false);
        setDieselRangeInvalid(false);
        setPropaneRangeInvalid(false);
    };

    const decrementPrice = (type: string) => {
        var price = 0;
        switch (type) {
            case 'Electric':
                price = parseFloat(electricityPrice);
                price = price - .0100;
                if (price <= electricPriceMax && price >= electricPriceMin) {
                    setElectricityPrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setElectricPriceUpDisabled(false);
                    setElectricPriceDownDisabled(false);
                }
                else if (price > electricPriceMax) {
                    setElectricityPrice(electricPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setElectricPriceUpDisabled(true);
                    setElectricPriceDownDisabled(false);
                }
                else if (price < electricPriceMin) {
                    setElectricityPrice(electricPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setElectricPriceDownDisabled(true);
                    setElectricPriceUpDisabled(false);
                }
                break;
            case 'Gas':
                price = parseFloat(gasPrice);
                price = price - .0100;
                if (price >= fuelPriceMin && price <= fuelPriceMax) {
                    setGasPrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setGasPriceUpDisabled(false);
                    setGasPriceDownDisabled(false);
                }
                else if (price > fuelPriceMax) {
                    setGasPrice(fuelPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setGasPriceUpDisabled(true);
                    setGasPriceDownDisabled(false);
                }
                else if (price < fuelPriceMin) {
                    setGasPrice(fuelPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setGasPriceDownDisabled(true);
                    setGasPriceUpDisabled(false);
                }
                break;
            case 'Diesel':
                price = parseFloat(dieselPrice);
                price = price - .0100;
                if (price >= fuelPriceMin && price <= fuelPriceMax) {
                    setDieselPrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setDieselPriceUpDisabled(false);
                    setDieselPriceDownDisabled(false);
                }
                else if (price > fuelPriceMax) {
                    setDieselPrice(fuelPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setDieselPriceUpDisabled(true);
                    setDieselPriceDownDisabled(false);
                }
                else if (price < fuelPriceMin) {
                    setDieselPrice(fuelPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setDieselPriceDownDisabled(true);
                    setDieselPriceUpDisabled(false);
                }
                break;
            case 'Propane':
                price = parseFloat(propranePrice);
                price = price - .0100;
                if (price >= fuelPriceMin && price <= fuelPriceMax) {
                    setPropanePrice(price.toFixed(2));
                    setAnyValueHasChanged(true);
                    setPropanePriceUpDisabled(false);
                    setPropanePriceDownDisabled(false);
                }
                else if (price > fuelPriceMax) {
                    setPropanePrice(fuelPriceMax.toFixed(2));
                    setAnyValueHasChanged(true);
                    setPropanePriceUpDisabled(true);
                    setPropanePriceDownDisabled(false);
                }
                else if (price < fuelPriceMin) {
                    setPropanePrice(fuelPriceMin.toFixed(2));
                    setAnyValueHasChanged(true);
                    setPropanePriceDownDisabled(true);
                    setPropanePriceUpDisabled(false);
                }
                break;
        }
        setElectricRangeInvalid(false);
        setGasRangeInvalid(false);
        setDieselRangeInvalid(false);
        setPropaneRangeInvalid(false);
    };

    const getPricing = () => {
        fetchWrapper.get(`fueltype/${fleetID}/${applicationName}`)
            .then((data) => {
                setFuelPriceList(data.fuelTypes);
                resetValidity();
                data.fuelTypes.forEach((item: any) => {
                    if (item.fuelTypeName === 'Electricity') {
                        setElectricityPrice(item.energyPrice.toFixed(2));
                    }
                    if (item.fuelTypeName === 'Gasoline') {
                        setGasPrice(item.energyPrice.toFixed(2));
                    }
                    if (item.fuelTypeName === 'Diesel') {
                        setDieselPrice(item.energyPrice.toFixed(2));
                    }
                    if (item.fuelTypeName === 'Propane') {
                        setPropanePrice(item.energyPrice.toFixed(2));
                    }
                })
            });
    };

    const recalculateClick = async () => {
        resetValidity();
        if (validate()) {
            await processFuelTypeChanges();
        }
    };

    const validate = () => {
        var price = 0;
        var hasError = false;

        fuelPriceList.forEach(async (fuelType: IFuelType) => {
            switch (fuelType.fuelTypeName) {
                case 'Electricity':
                    price = parseFloat(electricityPrice);
                    if (isNaN(price) || price > electricPriceMax || price < electricPriceMin) {
                        setElectricRangeInvalid(true);
                        hasError = true;
                    }
                    if (price > electricPriceMax) {
                        setElectricPriceUpDisabled(true);
                    }
                    else if (price < electricPriceMin) {
                        setElectricPriceDownDisabled(true);
                    }
                    else {
                        setElectricPriceUpDisabled(false);
                        setElectricPriceDownDisabled(false);
                    }
                    break;
                case 'Gasoline':
                    price = parseFloat(gasPrice);
                    if (isNaN(price) || price > fuelPriceMax || price < fuelPriceMin) {
                        setGasRangeInvalid(true);
                        hasError = true;
                    }
                    if (price > fuelPriceMax) {
                        setGasPriceUpDisabled(true);
                    }
                    else if (price < fuelPriceMin) {
                        setGasPriceDownDisabled(true);
                    }
                    else {
                        setGasPriceUpDisabled(false);
                        setGasPriceDownDisabled(false);
                    }
                    break;
                case 'Diesel':
                    price = parseFloat(dieselPrice);
                    if (isNaN(price) || price > fuelPriceMax || price < fuelPriceMin) {
                        setDieselRangeInvalid(true);
                        hasError = true;
                    }
                    if (price > fuelPriceMax) {
                        setDieselPriceUpDisabled(true);
                    }
                    else if (price < fuelPriceMin) {
                        setDieselPriceDownDisabled(true);
                    }
                    else {
                        setDieselPriceUpDisabled(false);
                        setDieselPriceDownDisabled(false);
                    }
                    break;
                case 'Propane':
                    price = parseFloat(propranePrice);
                    if (isNaN(price) || price > fuelPriceMax || price < fuelPriceMin) {
                        setPropaneRangeInvalid(true);
                        hasError = true;
                    }
                    if (price > fuelPriceMax) {
                        setPropanePriceUpDisabled(true);
                    }
                    else if (price < fuelPriceMin) {
                        setPropanePriceDownDisabled(true);
                    }
                    else {
                        setPropanePriceUpDisabled(false);
                        setPropanePriceDownDisabled(false);
                    }
                    break;
            }
        });
        console.log("hasError: ", hasError);
        return !hasError;
    }

    const processFuelTypeChanges = async () => {
        var updateComplete = false;
        fuelPriceList.forEach(async (fuelType: IFuelType) => {
            switch (fuelType.fuelTypeName) {
                case 'Electricity':
                    if (electricityPrice !== fuelType.energyPrice.toFixed(2)) {
                        await updateFuelType(fuelType.fuelTypeID, electricityPrice);
                    }
                    break;
                case 'Gasoline':
                    if (gasPrice !== fuelType.energyPrice.toFixed(2)) {
                        await updateFuelType(fuelType.fuelTypeID, gasPrice);
                    }
                    break;
                case 'Diesel':
                    if (dieselPrice !== fuelType.energyPrice.toFixed(2)) {
                        await updateFuelType(fuelType.fuelTypeID, dieselPrice);
                    }
                    break;
                case 'Propane':
                    if (propranePrice !== fuelType.energyPrice.toFixed(2)) {
                        await updateFuelType(fuelType.fuelTypeID, propranePrice);
                    }
                    break;
            }
        });
        return updateComplete;
    }

    const errorClass = (hasError: boolean) => {
        return (hasError ? 'is-invalid' : '');
    }

    const updateFuelType = async (fuelTypeID: any, fuelPrice: any) => {
        var fuelTypeUpdateRequest = {
            fleetID: fleetID,
            fuelTypeID: fuelTypeID,
            priceOverride: fuelPrice,
            applicationName: applicationName
        };

        fetchWrapper.post('fuelType/update', 'application/json', fuelTypeUpdateRequest)
            .then((data) => {
                if (data.success) {
                    setFuelPriceList(data.fuelTypes);
                    setAnyValueHasChanged(false);
                    submitHandler();
                }
            });
    }

    const resetValidity = () => {
        setElectricRangeInvalid(false);
        setGasRangeInvalid(false);
        setDieselRangeInvalid(false);
        setPropaneRangeInvalid(false);
        setElectricPriceDownDisabled(false);
        setElectricPriceUpDisabled(false);
        setGasPriceDownDisabled(false);
        setGasPriceUpDisabled(false);
        setDieselPriceDownDisabled(false);
        setDieselPriceUpDisabled(false);
        setPropanePriceDownDisabled(false);
        setPropanePriceUpDisabled(false);
    }

    return (
            <ContentBlock className="filterControl">
                    <Card>
                        <CardHeader>
                            <Row className="closeButtonRow">
                                <Col>
                                    <h4 className="css_heading bold">Fine tune your Fleet Estimate</h4>
                                </Col>
                                <Col className="text-align-right">
                                    <Button className="submitButton hollowNeg secondaryButton iconCloseX" onClick={closeHandler}></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="fineTuneBody">
                            <Row>
                                <Col className="subtitle">
                                    Your Fleet Estimate uses certain assumptions, reflected in the values below. The assumptions are based on your organization type and your location.
                                    If the assumptions are incorrect, feel free to adjust the values to more accurately reflect your situation, or to try out some speculative scenarios.

                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p className="boldDirections top">Click the arrows or type in new numbers to adjust the values...</p>
                                </Col>
                            </Row>
                            <Row className="fineTuneAdjustments">
                                <Col className="adjustmentColumn" lg={3} md={3} xs={12}>
                                    <div className="keepItTogether">
                                        <Row className="adjustmentContainer">
                                            <Col sm={5} xs={5} className="priceAdjuster">
                                                <Button className={`submitButton iconUpArrowBlue ${electricPriceUpDisabled ? "disabled" : ""}`} onClick={() => { incrementPrice('Electric'); }}></Button>
                                                <Input className="priceInput" type="text" name="elPrice" id="ElectricPrice" maxLength={10} value={electricityPrice} onChange={electricityPriceInputChange} />
                                                <Button className={`submitButton iconDownArrowBlue ${electricPriceDownDisabled ? "disabled" : ""}`} onClick={() => { decrementPrice('Electric'); }} ></Button>
                                            </Col>
                                            <Col sm={7} xs={7} className="fuelType">
                                                <p><strong>Electricity</strong><br />
                                                    per kWh
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} xs={12} className={`range ${errorClass(electricRangeInvalid)}`}>Range: ${electricPriceMin.toFixed(2)} - ${electricPriceMax.toFixed(2)}</Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="adjustmentColumn" lg={3} md={3} xs={12}>
                                    <div className="keepItTogether">

                                        <Row className="adjustmentContainer">
                                            <Col sm={5} xs={5} className="priceAdjuster">
                                                <Button className={`submitButton iconUpArrowBlue ${gasPriceUpDisabled ? "disabled" : ""}`} onClick={() => { incrementPrice('Gas'); }}></Button>
                                                <Input className="priceInput" type="text" name="gasPrice" id="GasPrice" maxLength={10} value={gasPrice} onChange={gasPriceInputChange} />
                                                <Button className={`submitButton iconDownArrowBlue ${gasPriceDownDisabled ? "disabled" : ""}`} onClick={() => { decrementPrice('Gas'); }}></Button>
                                            </Col>
                                            <Col sm={7} xs={7} className="fuelType">
                                                <p><strong>Gasoline</strong><br />
                                                    per gallon
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} xs={12} className={`range ${errorClass(gasRangeInvalid)}`}>Range: $1.00 - ${fuelPriceMax.toFixed(2)}</Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="adjustmentColumn" lg={3} md={3} xs={12}>
                                    <div className="keepItTogether">

                                        <Row className="adjustmentContainer">
                                            <Col sm={5} xs={5} className="priceAdjuster">
                                                <Button className={`submitButton iconUpArrowBlue ${dieselPriceUpDisabled ? "disabled" : ""}`} onClick={() => { incrementPrice('Diesel'); }}></Button>
                                                <Input className="priceInput" type="text" name="dieselPrice" id="DieselPrice" maxLength={10} value={dieselPrice} onChange={dieselPriceInputChange} />
                                                <Button className={`submitButton iconDownArrowBlue ${dieselPriceDownDisabled ? "disabled" : ""}`} onClick={() => { decrementPrice('Diesel'); }}></Button>
                                            </Col>
                                            <Col sm={7} xs={7} className="fuelType">
                                                <p><strong>Diesel</strong><br />
                                                    per gallon
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} xs={12} className={`range ${errorClass(dieselRangeInvalid)}`}>Range: $1.00 - ${fuelPriceMax.toFixed(2)}</Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="adjustmentColumn" lg={3} md={3} xs={12}>
                                    <div className="keepItTogether">
                                        <Row className="adjustmentContainer">
                                            <Col sm={5} xs={5} className="priceAdjuster">
                                                <Button className={`submitButton iconUpArrowBlue ${propanePriceUpDisabled ? "disabled" : ""}`} onClick={() => { incrementPrice('Propane'); }}></Button>
                                                <Input className="priceInput" type="text" name="propanePrice" id="PropanePrice" maxLength={10} value={propranePrice} onChange={propanePriceInputChange} />
                                                <Button className={`submitButton iconDownArrowBlue ${propanePriceDownDisabled ? "disabled" : ""}`} onClick={() => { decrementPrice('Propane'); }}></Button>
                                            </Col>
                                            <Col sm={7} xs={7} className="fuelType">
                                                <p><strong>Propane</strong><br />
                                                    per gallon
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} xs={12} className={`range ${errorClass(propaneRangeInvalid)}`}>Range: $1.00 - ${fuelPriceMax.toFixed(2)}</Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <p className="boldDirections">...then click Recalculate to refresh your results!</p>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <Row className="submitButtonRow">
                                <Col>
                                    {anyValueHasChanged ? (
                                        <Button className="submitButton solidNeg primaryButton iconCalculator" onClick={recalculateClick}>Recalculate</Button>
                                    ) : (
                                        <Button className="submitButton solidNeg primaryButton iconCalculator" disabled>Recalculate</Button>
                                    )}
                                </Col>
                            </Row>
                        </CardFooter>
                    </Card>
             </ContentBlock>
    );
}
